import {
  FileSignature,
  Handshake,
  Hash,
  IdCard,
  ImageIcon,
  PenLine,
  ScrollText,
  Stamp,
  UserRound,
} from 'lucide-react';
import { Link } from 'react-router';
import {
  AvisosDeAjustes,
  BannerDeActivacion,
  BarraDeGuardado,
  Campo,
  CargandoAjustes,
  FalloDeAjustes,
  Seccion,
  entrada,
  useAjustes,
} from './ajustes';

export function PaginaDocumentos() {
  const ajustes = useAjustes(['documentos']);

  if (ajustes.cargando) {
    return <CargandoAjustes bloques={2} />;
  }
  if (ajustes.fallo) {
    return <FalloDeAjustes causa={ajustes.fallo} />;
  }

  const sobrePapel = ajustes.booleano('fondo_en_comprobantes');
  const elaboradoPor = ajustes.texto('constancia_elaborado_por');
  const elaboradoCargo = ajustes.texto('constancia_elaborado_cargo');
  const autorizadoPor = ajustes.texto('constancia_autorizado_por');
  const autorizadoCargo = ajustes.texto('constancia_autorizado_cargo');

  return (
    <div className="grid gap-6">
      <AvisosDeAjustes ajustes={ajustes} />

      <BannerDeActivacion
        icono={Stamp}
        activo={sobrePapel}
        titulo={
          sobrePapel
            ? 'Los comprobantes se imprimen sobre el papel corporativo'
            : 'Los comprobantes salen en hoja blanca'
        }
        descripcion={
          sobrePapel
            ? 'Se ven como los de ventanilla, pero cada correo pesa más'
            : 'Pesan menos en el correo; el RIDE sale sin membrete'
        }
        alCambiar={() => ajustes.alternar('fondo_en_comprobantes', sobrePapel)}
      />

      <Seccion icono={FileSignature} color="indigo" titulo="Firmas de la constancia del Art. 8">
        <p className="mb-4 text-xs uppercase leading-relaxed text-armazon-500">
          Salen impresos bajo cada línea de firma. Déjelos vacíos si prefiere que la constancia se
          firme a mano.
        </p>

        <div className="grid gap-5 lg:grid-cols-2">
          <div className="grid gap-4 rounded-xl border border-armazon-200 p-4">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-armazon-500">
              Elaborado por
            </p>
            <Campo etiqueta="Nombre" icono={UserRound}>
              <input
                value={elaboradoPor}
                onChange={(e) => ajustes.editar('constancia_elaborado_por', e.target.value)}
                placeholder="NOMBRE Y APELLIDOS"
                maxLength={120}
                className={`${entrada} pl-10`}
              />
            </Campo>
            <Campo etiqueta="Cargo" icono={IdCard}>
              <input
                value={elaboradoCargo}
                onChange={(e) => ajustes.editar('constancia_elaborado_cargo', e.target.value)}
                placeholder="ANALISTA DE CARTERA"
                maxLength={120}
                className={`${entrada} pl-10`}
              />
            </Campo>
          </div>

          <div className="grid gap-4 rounded-xl border border-armazon-200 p-4">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-armazon-500">
              Autorizado por
            </p>
            <Campo etiqueta="Nombre" icono={UserRound}>
              <input
                value={autorizadoPor}
                onChange={(e) => ajustes.editar('constancia_autorizado_por', e.target.value)}
                placeholder="NOMBRE Y APELLIDOS"
                maxLength={120}
                className={`${entrada} pl-10`}
              />
            </Campo>
            <Campo etiqueta="Cargo" icono={IdCard}>
              <input
                value={autorizadoCargo}
                onChange={(e) => ajustes.editar('constancia_autorizado_cargo', e.target.value)}
                placeholder="TESORERA"
                maxLength={120}
                className={`${entrada} pl-10`}
              />
            </Campo>
          </div>
        </div>

        <div className="mt-5 rounded-xl border border-armazon-200 bg-armazon-50 p-4">
          <p className="mb-3 text-[10px] font-semibold uppercase tracking-wider text-armazon-500">
            Así saldrá al pie de la constancia
          </p>
          <div className="grid gap-6 sm:grid-cols-2">
            <PieDeFirma rotulo="Elaborado por" nombre={elaboradoPor} cargo={elaboradoCargo} />
            <PieDeFirma rotulo="Autorizado por" nombre={autorizadoPor} cargo={autorizadoCargo} />
          </div>
        </div>
      </Seccion>

      <Seccion icono={Handshake} color="indigo" titulo="Firmas del convenio de pago">
        <p className="mb-4 text-xs uppercase leading-relaxed text-armazon-500">
          Autoriza la Gerencia General, revisa Asesoría Jurídica y elabora Tesorería. Mientras el
          nombre del gerente esté vacío, el convenio sale con «&lt;GERENTE GENERAL&gt;».
        </p>
        <div className="grid gap-4 lg:grid-cols-2">
          <Campo etiqueta="Gerente General" icono={UserRound}>
            <input
              value={ajustes.texto('convenio_gerente_nombre')}
              onChange={(e) => ajustes.editar('convenio_gerente_nombre', e.target.value)}
              placeholder="NOMBRE Y APELLIDOS"
              maxLength={120}
              className={`${entrada} pl-10`}
            />
          </Campo>
          <Campo etiqueta="Cargo" icono={IdCard}>
            <input
              value={ajustes.texto('convenio_gerente_cargo')}
              onChange={(e) => ajustes.editar('convenio_gerente_cargo', e.target.value)}
              placeholder="GERENTE GENERAL"
              maxLength={120}
              className={`${entrada} pl-10`}
            />
          </Campo>
          <Campo etiqueta="Revisado por (Jurídico)" icono={UserRound}>
            <input
              value={ajustes.texto('convenio_revisado_por')}
              onChange={(e) => ajustes.editar('convenio_revisado_por', e.target.value)}
              placeholder="NOMBRE Y APELLIDOS"
              maxLength={120}
              className={`${entrada} pl-10`}
            />
          </Campo>
          <Campo etiqueta="Elaborado por (Tesorería)" icono={UserRound}>
            <input
              value={ajustes.texto('convenio_elaborado_por')}
              onChange={(e) => ajustes.editar('convenio_elaborado_por', e.target.value)}
              placeholder="NOMBRE Y APELLIDOS"
              maxLength={120}
              className={`${entrada} pl-10`}
            />
          </Campo>
        </div>
      </Seccion>

      <Seccion icono={ScrollText} color="indigo" titulo="Título de crédito">
        <div className="grid gap-4 lg:grid-cols-2">
          <Campo etiqueta="Quién lo firma" icono={UserRound}>
            <input
              value={ajustes.texto('titulo_credito_firma_nombre')}
              onChange={(e) => ajustes.editar('titulo_credito_firma_nombre', e.target.value)}
              placeholder="NOMBRE Y APELLIDOS"
              maxLength={120}
              className={`${entrada} pl-10`}
            />
          </Campo>
          <Campo
            etiqueta="Primer número del año"
            icono={Hash}
            ayuda="Para seguir la numeración que Tesorería ya lleva a mano"
          >
            <input
              value={ajustes.texto('titulo_credito_primer_numero')}
              onChange={(e) =>
                ajustes.editar('titulo_credito_primer_numero', e.target.value.replace(/\D/g, ''))
              }
              inputMode="numeric"
              maxLength={9}
              className={`${entrada} pl-10`}
            />
          </Campo>
          <div className="lg:col-span-2">
            <Campo etiqueta="Cargo de quien firma" icono={IdCard}>
              <input
                value={ajustes.texto('titulo_credito_firma_cargo')}
                onChange={(e) => ajustes.editar('titulo_credito_firma_cargo', e.target.value)}
                maxLength={200}
                className={`${entrada} pl-10`}
              />
            </Campo>
          </div>
          <div className="lg:col-span-2">
            <Campo etiqueta="Ordenanza que cita">
              <textarea
                value={ajustes.texto('titulo_credito_ordenanza')}
                onChange={(e) => ajustes.editar('titulo_credito_ordenanza', e.target.value)}
                rows={3}
                className={AREA}
              />
            </Campo>
          </div>
          <div className="lg:col-span-2">
            <Campo etiqueta="Dónde y cómo se paga">
              <textarea
                value={ajustes.texto('titulo_credito_forma_de_pago')}
                onChange={(e) => ajustes.editar('titulo_credito_forma_de_pago', e.target.value)}
                rows={3}
                className={AREA}
              />
            </Campo>
          </div>
        </div>
      </Seccion>

      <p className="flex items-center gap-2 rounded-xl border border-armazon-200 bg-armazon-50 px-4 py-3 text-xs uppercase leading-relaxed text-armazon-600">
        <ImageIcon className="size-4 shrink-0 text-armazon-400" aria-hidden />
        <span>
          La hoja con cabecera y pie (el membrete, con su año) se sube en{' '}
          <Link to="/firma-electronica" className="font-semibold text-marca-700 hover:underline">
            Firma electrónica
          </Link>
          . Cada año se reemplaza por la del año nuevo y la usan el convenio, el título de crédito y
          los certificados.
        </span>
      </p>

      <BarraDeGuardado ajustes={ajustes} />
    </div>
  );
}

const AREA =
  'w-full rounded-lg border border-armazon-200 bg-white px-3 py-2 text-sm text-armazon-900 outline-none focus:border-marca-400 focus:ring-2 focus:ring-marca-500/20';

function PieDeFirma({ rotulo, nombre, cargo }: { rotulo: string; nombre: string; cargo: string }) {
  return (
    <div className="text-center">
      <div className="mx-auto mb-1 w-4/5 border-t border-armazon-400" />
      <p className="text-[11px] font-bold uppercase tracking-wide text-armazon-700">{rotulo}</p>
      {nombre.trim() === '' ? (
        <p className="mt-1 flex items-center justify-center gap-1 text-[10px] uppercase text-armazon-400">
          <PenLine className="size-3" aria-hidden /> Se firma a mano
        </p>
      ) : (
        <p className="mt-1 text-[10px] uppercase leading-relaxed text-armazon-600">
          <span className="font-semibold text-armazon-800">{nombre}</span>
          <br />
          {cargo.trim() === '' ? 'EPAGAL EP' : `${cargo} · EPAGAL EP`}
        </p>
      )}
    </div>
  );
}
